import CONFIG from "config/config";

export const Enpoint = " https://api.sandbox.com.vn";
export const SandboxOrigin = "https://shopdunk.sandbox.com.vn";
export const SandBoxUserName = "shopdunk.deposit";
export const SandBoxPassword = "Shopdunk8386@@";

export const SDUserName = "shopdunkweb";
export const SDPassword = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9";

export const DEPOSIT = CONFIG.DEPOSIT;

export const REGEX_EMAIL = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const REGEX_PHONE_NUMBER = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;

export const BASENAME = CONFIG.BASENAME;

export const BASENAMEcomming = CONFIG.BASENAME_COMING;

export const GENDERS = [
  {
    label: "Nam",
    value: 1,
  },
  {
    label: "Nữ",
    value: 0,
  },
  {
    label: "Khác",
    value: "",
  },
];

export const AREA = [
  {
    label: "HN",
    value: 1,
  },
  {
    label: "HCM",
    value: 2,
  }
];

export const KHO_MIEN_BAC = [
  "HNI03-143TH",
  "HNI04-76TH",
  "HNI08-02HB",
  "HNI09-386CG",
  "HNI10-281HTM",
  "HNI12-275MK",
  "HNI21-174QT",
  "HNI26-239LLQ",
  "HNI28-33NXQ",
  "HNI29-63NH",
  "HNI30-286NVC",
  "HNM01-116BH",
  "HNI31-35LVL",
  "HNI34-AEONMALLSDPLUS",
  "HPH03-AEONMALLHP",
  "DNG02-237DBP",
  "HUI01-AEONMALLHUE",
  "NDH02-03DC",
  "TBH01-08VC"
];

export const KHO_MIEN_NAM = [
  "HCM03-120PDL",
  "HCM01-133D3-2",
  "HCM14-59VVN",
  "HCM12-581PVT",
  "HCM19-728TL10",
  "HCM02-467QT",
  "HCM09-274XVNT",
  "HCM17-16LVV",
  "HCM34-AEONTANPHU"
];

export const META_CONFIG = {
  // iPhone 17
  "/dien-thoai-iphone-17-256gb": {
    title: "Đặt cọc iPhone 17 256GB | Xanh lam khói chất, trả góp 0%",
    description:
      "Đặt cọc iPhone 17 256GB tại ShopDunk để giữ suất sớm. Trả góp 0% dễ dàng, bảo hành 36 tháng chính hãng, ưu đãi hấp dẫn khi mở bán. Xanh lam khói hot pick ngay sau tím oải hương",
  },
  "/dien-thoai-iphone-17-512gb": {
    title: "Đặt cọc iPhone 17 512GB | Giá tốt, mua tín dụng giảm sâu",
    description:
      "Nhanh tay đặt cọc iPhone 17 512GB, giá ưu đãi, hỗ trợ mua tín dụng giảm sâu. Hàng về sớm, giao nhanh, số lượng có hạn tại ShopDunk.",
  },

  // iPhone 17 Air
  "/dien-thoai-iphone-air-256gb": {
    title: "Đặt cọc iPhone Air 256GB | Skyblue quá nét, bảo hành 3 năm",
    description:
      "Đặt cọc iPhone Air 256GB hôm nay, tận hưởng chương trình thu cũ đổi mới tiết kiệm. iPhone 17 Air bảo hành chính hãng 3 năm, trả góp linh hoạt. Sky blue đẹp hơn Macbook Air M4",
  },
  "/dien-thoai-iphone-air-512gb": {
    title: "Đặt cọc iPhone Air 512GB | Trả góp 0%, ưu đãi lên đời",
    description:
      "Đặt cọc giữ suất iPhone Air 512GB, ưu đãi lên đời siêu lợi. Trả góp 0%, bảo hành dài hạn, ShopDunk giao hàng sớm khi iPhone 17 Air 512GB về.",
  },
  "/dien-thoai-iphone-air-1tb": {
    title: "Đặt cọc iPhone Air 1TB | Dung lượng thoải mái, bảo hành 36 tháng",
    description:
      "Đặt cọc iPhone Air 1TB dung lượng khủng, lưu trữ thả ga. Bảo hành chính hãng 36 tháng, hỗ trợ trả góp nhanh gọn, quà tặng mở bán.",
  },

  // iPhone 17 Pro
  "/dien-thoai-iphone-17-pro-256gb": {
    title: "Đặt cọc iPhone 17 Pro 256GB | Cam vũ trụ quá đẹp, trả góp 0%",
    description:
      "Đặt cọc iPhone 17 Pro 256GB ngay hôm nay. Trả góp 0%, thu cũ đổi mới tiết kiệm, ưu đãi độc quyền, giao máy sớm tại ShopDunk. Màu Cam vũ trụ quá là nét so với các năm trước!",
  },
  "/dien-thoai-iphone-17-pro-512gb": {
    title: "Đặt cọc iPhone 17 Pro 512GB | Xanh đậm hot pick, bảo hành 3 năm",
    description:
      "Nhanh tay đặt cọc iPhone 17 Pro 512GB. Ưu đãi tín dụng, bảo hành 3 năm chính hãng, nhận máy sớm với giá ưu đãi tại ShopDunk. Xanh đậm bán rất tốt!",
  },
  "/dien-thoai-iphone-17-pro-1tb": {
    title: "Đặt cọc iPhone 17 Pro 1TB | Siêu dung lượng, trả góp 0%",
    description:
      "Đặt cọc iPhone 17 Pro 1TB siêu dung lượng. Hỗ trợ trả góp 0%, bảo hành chính hãng, giữ slot nhận máy sớm, ưu đãi độc quyền.",
  },

  // iPhone 17 Pro Max
  "/dien-thoai-iphone-17-pro-max-256gb": {
    title: "Đặt cọc iPhone 17 Pro Max 256GB | Xanh đậm cọc nhiều, giá tốt",
    description:
      "Đặt cọc iPhone 17 Pro Max 256GB, siêu phẩm giá tốt. Trả góp 0% nhanh gọn, nhận máy sớm, số lượng giới hạn tại ShopDunk. Màu xanh đậm nhiều người mua!",
  },
  "/dien-thoai-iphone-17-pro-max-512gb": {
    title: "Đặt cọc iPhone 17 Pro Max 512GB | Cam vũ trụ trông mê, bảo hành 36 tháng",
    description:
      "Đặt cọc iPhone 17 Pro Max 512GB, ưu đãi độc quyền chỉ có tại ShopDunk. Bảo hành chính hãng 3 năm, giao nhanh ngay khi máy về. Màu Cam vũ trụ đang bán rất chạy!",
  },
  "/dien-thoai-iphone-17-pro-max-1tb": {
    title: "Đặt cọc iPhone 17 Pro Max 1TB | Thu cũ đổi mới, trả góp 0%",
    description:
      "Đặt cọc giữ suất sớm iPhone 17 Pro Max 1TB, thu cũ đổi mới tiết kiệm. Trả góp 0% lãi suất, nhận hàng nhanh, quà tặng mở bán giới hạn.",
  },
  "/dien-thoai-iphone-17-pro-max-2tb": {
    title: "Đặt cọc iPhone 17 Pro Max 2TB | Dung lượng khủng, bảo hành 3 năm",
    description:
      "Đặt cọc iPhone 17 Pro Max 2TB dung lượng khủng. Bảo hành chính hãng 3 năm, hỗ trợ trả góp dễ dàng, ưu đãi lớn tại ShopDunk.",
  },
};

export const META_CONFIG_16N = {
  "/dien-thoai-iphone-16n": {
    title: "iPhone 16n Series | Đặt Cọc Ngay – Giữ Suất Đầu Tiên",
    description:
      "Đặt cọc iPhone 16n Series ngay hôm nay tại ShopDunk. Giữ slot nhận máy sớm nhất, trả góp 0%, giá tốt cùng ưu đãi mở bán giới hạn.",
  },
  "/dien-thoai-iphone-16n-128gb": {
    title: "iPhone 16n 128GB | Đặt Cọc Sớm – Không Lo Cháy Hàng",
    description:
      "Đặt cọc iPhone 16n 128GB để chắc suất nhận sớm. Giá tốt tại ShopDunk, trả góp 0% dễ dàng. Hàng về giao nhanh, không lo cháy hàng.",
  },
  "/dien-thoai-iphone-16n-256gb": {
    title: "iPhone 16n 256GB | Đặt Trước Ngay – Giữ Suất Độc Quyền",
    description:
      "Nhanh tay đặt cọc iPhone 16n 256GB. Trả góp 0%, ưu đãi độc quyền. Giao hàng sớm cho khách đặt trước, số lượng có hạn.",
  },
  "/dien-thoai-iphone-16n-512gb": {
    title: "iPhone 16n 512GB | Đặt Cọc Hôm Nay – Nhận Đầu Tiên",
    description:
      "Đặt trước iPhone 16n 512GB ngay hôm nay. Giá hấp dẫn, hỗ trợ trả góp 0%. Giao hàng sớm nhất tại ShopDunk, không lo hết slot.",
  },

  // iPhone 16n Plus
  "/dien-thoai-iphone-16n-plus-128gb": {
    title: "iPhone 16n Plus 128GB | Đặt Cọc Nhanh – Có Suất Ngay",
    description:
      "Đặt cọc iPhone 16n Plus 128GB tại ShopDunk. Trả góp 0% nhẹ nhàng, giá tốt. Giao hàng sớm cho khách đặt trước, số lượng giới hạn.",
  },
  "/dien-thoai-iphone-16n-plus-256gb": {
    title: "iPhone 16n Plus 256GB | Giữ Slot Trước – Hàng Về Liền Tay",
    description:
      "Giữ slot iPhone 16n Plus 256GB tại ShopDunk. Ưu đãi giá sốc, hỗ trợ trả góp 0%, giao nhanh nhất tại ShopDunk.",
  },
  "/dien-thoai-iphone-16n-plus-512gb": {
    title: "iPhone 16n Plus 512GB | Đặt Cọc Sớm – Sở Hữu Đỉnh Cao",
    description:
      "Đặt trước iPhone 16n Plus 512GB để nhận máy sớm nhất. ShopDunk hỗ trợ trả góp 0%, giá tốt, cam kết giao nhanh khi hàng về.",
  },

  // iPhone 16n Air
  "/dien-thoai-iphone-16n-air-128gb": {
    title: "iPhone 16n Air 128GB | Đặt Cọc Ngay – Mỏng Nhẹ Đón Đầu",
    description:
      "Đặt cọc iPhone 16n Air 128GB ngay hôm nay. Trả góp 0% dễ dàng, giá tốt. Giao hàng sớm, trở thành người sở hữu đầu tiên.",
  },
  "/dien-thoai-iphone-16n-air-256gb": {
    title: "iPhone 16n Air 256GB | Đặt Trước Hôm Nay – Nhận Sớm Nhất",
    description:
      "Giữ slot iPhone 16n Air 256GB tại ShopDunk. Ưu đãi trả góp 0%, giá hấp dẫn. Đặt trước để chắc suất nhận máy sớm nhất.",
  },
  "/dien-thoai-iphone-16n-air-512gb": {
    title: "iPhone 16n Air 512GB | Giữ Suất Đặt Cọc – Trải Nghiệm Trước",
    description:
      "Đặt cọc iPhone 16n Air 512GB ngay hôm nay. Hỗ trợ trả góp 0%, giá ưu đãi. ShopDunk giao hàng sớm khi có hàng về.",
  },

  // iPhone 16n Pro
  "/dien-thoai-iphone-16n-pro-128gb": {
    title: "iPhone 16n Pro 128GB | Đặt Cọc Liền Tay – Giữ Slot Hot",
    description:
      "Đặt cọc iPhone 16n Pro 128GB để chắc suất nhận máy sớm. Trả góp 0%, giá ưu đãi chỉ tại ShopDunk. Số lượng đặt trước có hạn.",
  },
  "/dien-thoai-iphone-16n-pro-256gb": {
    title: "iPhone 16n Pro 256GB | Đặt Trước Hôm Nay – Nhận Đầu Tiên",
    description:
      "Nhanh tay đặt cọc iPhone 16n Pro 256GB. Hỗ trợ trả góp 0%, giá tốt. Giao hàng nhanh cho khách đặt cọc tại ShopDunk.",
  },
  "/dien-thoai-iphone-16n-pro-512gb": {
    title: "iPhone 16n Pro 512GB | Giữ Suất Độc Quyền – Đặt Cọc Ngay",
    description:
      "Đặt cọc iPhone 16n Pro 512GB ngay hôm nay. Ưu đãi giá sốc, trả góp 0%. Giao hàng sớm, đảm bảo slot cho khách đặt trước.",
  },
  "/dien-thoai-iphone-16n-pro-1tb": {
    title: "iPhone 16n Pro 1TB | Đặt Cọc Sớm – Sở Hữu Dung Lượng Khủng",
    description:
      "Giữ slot iPhone 16n Pro 1TB dung lượng khủng. Đặt cọc để chắc suất, trả góp 0%, giá ưu đãi và giao hàng sớm nhất tại ShopDunk.",
  },

  // iPhone 16n Pro Max
  "/dien-thoai-iphone-16n-pro-max-256gb": {
    title: "iPhone 16n Pro Max 256GB | Đặt Trước – Trải Nghiệm Đầu Tiên",
    description:
      "Đặt trước iPhone 16n Pro Max 256GB. ShopDunk hỗ trợ trả góp 0%, giá tốt. Nhận hàng sớm nhất khi về, suất đặt cọc cực giới hạn.",
  },
  "/dien-thoai-iphone-16n-pro-max-512gb": {
    title: "iPhone 16n Pro Max 512GB | Đặt Cọc Hot – Hàng Về Liền Tay",
    description:
      "Đặt cọc iPhone 16n Pro Max 512GB ngay hôm nay. Trả góp 0%, giá cực hot. Giao hàng nhanh cho khách giữ slot đầu tiên.",
  },
  "/dien-thoai-iphone-16n-pro-max-1tb": {
    title: "iPhone 16n Pro Max 1TB | Giữ Slot Vip – Đặt Trước Ngay",
    description:
      "Sở hữu iPhone 16n Pro Max 1TB với slot VIP. Đặt cọc trước để chắc suất, trả góp 0% và nhận máy sớm nhất tại ShopDunk.",
  },
};

export const META_CONFIG_18 = {
  // iPhone 18 Pro
  "/dien-thoai-iphone-18-pro-256gb": {
    title: "iPhone 18 Pro 256GB giá từ 38.999.000đ - Mở bán 18/9",
    description:
      "iPhone 18 Pro 256GB giá từ 38.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-18-pro-256gb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-18-pro-256gb",
      title:
        "iPhone 18 Pro 256GB giá từ 38.999.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro 256GB giá từ 38.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone 18 Pro 256GB giá từ 38.999.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro 256GB giá từ 38.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-256gb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-18-pro-256gb",
          name:
            "iPhone 18 Pro 256GB giá từ 38.999.000đ - Mở bán 18/9",
          description:
            "iPhone 18 Pro 256GB giá từ 38.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-18-pro-256gb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-256gb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone 18 Pro 256GB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-18-pro-256gb",
            },
          ],
        },
      ],
    },
  },
  "/dien-thoai-iphone-18-pro-512gb": {
    title: "iPhone 18 Pro 512GB giá từ 45.499.000đ - Mở bán 18/9",
    description:
      "iPhone 18 Pro 512GB giá từ 45.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-18-pro-512gb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-18-pro-512gb",
      title:
        "iPhone 18 Pro 512GB giá từ 45.499.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro 512GB giá từ 45.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone 18 Pro 512GB giá từ 45.499.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro 512GB giá từ 45.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-512gb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-18-pro-512gb",
          name:
            "iPhone 18 Pro 512GB giá từ 45.499.000đ - Mở bán 18/9",
          description:
            "iPhone 18 Pro 512GB giá từ 45.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-18-pro-512gb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-512gb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone 18 Pro 512GB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-18-pro-512gb",
            },
          ],
        },
      ],
    },
  },
  "/dien-thoai-iphone-18-pro-1tb": {
    title: "iPhone 18 Pro 1TB giá từ 58.499.000đ - Mở bán 18/9",
    description:
      "iPhone 18 Pro 1TB giá từ 58.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-18-pro-1tb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-18-pro-1tb",
      title:
        "iPhone 18 Pro 1TB giá từ 58.499.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro 1TB giá từ 58.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone 18 Pro 1TB giá từ 58.499.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro 1TB giá từ 58.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-1tb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-18-pro-1tb",
          name:
            "iPhone 18 Pro 1TB giá từ 58.499.000đ - Mở bán 18/9",
          description:
            "iPhone 18 Pro 1TB giá từ 58.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-18-pro-1tb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-1tb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone 18 Pro 1TB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-18-pro-1tb",
            },
          ],
        },
      ],
    },
  },
  "/dien-thoai-iphone-18-pro-2tb": {
    title: "iPhone 18 Pro 2TB giá từ 77.999.000đ - Mở bán 18/9",
    description:
      "iPhone 18 Pro 2TB giá từ 77.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-18-pro-2tb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-18-pro-2tb",
      title:
        "iPhone 18 Pro 2TB giá từ 77.999.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro 2TB giá từ 77.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone 18 Pro 2TB giá từ 77.999.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro 2TB giá từ 77.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-2tb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-18-pro-2tb",
          name:
            "iPhone 18 Pro 2TB giá từ 77.999.000đ - Mở bán 18/9",
          description:
            "iPhone 18 Pro 2TB giá từ 77.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-18-pro-2tb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-2tb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone 18 Pro 2TB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-18-pro-2tb",
            },
          ],
        },
      ],
    },
  },
  // iPhone 18 Pro Max
  "/dien-thoai-iphone-18-pro-max-256gb": {
    title: "iPhone 18 Pro Max 256GB giá từ 41.999.000đ - Mở bán 18/9",
    description:
      "iPhone 18 Pro Max 256GB giá từ 41.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-18-pro-max-256gb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-18-pro-max-256gb",
      title:
        "iPhone 18 Pro Max 256GB giá từ 41.999.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro Max 256GB giá từ 41.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone 18 Pro Max 256GB giá từ 41.999.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro Max 256GB giá từ 41.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-256gb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-256gb",
          name:
            "iPhone 18 Pro Max 256GB giá từ 41.999.000đ - Mở bán 18/9",
          description:
            "iPhone 18 Pro Max 256GB giá từ 41.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-18-pro-max-256gb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-256gb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone 18 Pro Max 256GB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-18-pro-max-256gb",
            },
          ],
        },
      ],
    },
  },
  "/dien-thoai-iphone-18-pro-max-512gb": {
    title: "iPhone 18 Pro Max 512GB giá từ 48.499.000đ - Mở bán 18/9",
    description:
      "iPhone 18 Pro Max 512GB giá từ 48.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-18-pro-max-512gb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-18-pro-max-512gb",
      title:
        "iPhone 18 Pro Max 512GB giá từ 48.499.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro Max 512GB giá từ 48.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone 18 Pro Max 512GB giá từ 48.499.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro Max 512GB giá từ 48.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-512gb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-512gb",
          name:
            "iPhone 18 Pro Max 512GB giá từ 48.499.000đ - Mở bán 18/9",
          description:
            "iPhone 18 Pro Max 512GB giá từ 48.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-18-pro-max-512gb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-512gb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone 18 Pro Max 512GB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-18-pro-max-512gb",
            },
          ],
        },
      ],
    },
  },
  "/dien-thoai-iphone-18-pro-max-1tb": {
    title: "iPhone 18 Pro Max 1TB giá từ 61.499.000đ - Mở bán 18/9",
    description:
      "iPhone 18 Pro Max 1TB giá từ 61.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-18-pro-max-1tb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-18-pro-max-1tb",
      title:
        "iPhone 18 Pro Max 1TB giá từ 61.499.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro Max 1TB giá từ 61.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone 18 Pro Max 1TB giá từ 61.499.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro Max 1TB giá từ 61.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-1tb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-1tb",
          name:
            "iPhone 18 Pro Max 1TB giá từ 61.499.000đ - Mở bán 18/9",
          description:
            "iPhone 18 Pro Max 1TB giá từ 61.499.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-18-pro-max-1tb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-1tb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone 18 Pro Max 1TB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-18-pro-max-1tb",
            },
          ],
        },
      ],
    },
  },
  "/dien-thoai-iphone-18-pro-max-2tb": {
    title: "iPhone 18 Pro Max 2TB giá từ 80.999.000đ - Mở bán 18/9",
    description:
      "iPhone 18 Pro Max 2TB giá từ 80.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-18-pro-max-2tb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-18-pro-max-2tb",
      title:
        "iPhone 18 Pro Max 2TB giá từ 80.999.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro Max 2TB giá từ 80.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone 18 Pro Max 2TB giá từ 80.999.000đ - Mở bán 18/9",
      description:
        "iPhone 18 Pro Max 2TB giá từ 80.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-18-pro/iPhone-18-Pro-Burgundy.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-2tb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-2tb",
          name:
            "iPhone 18 Pro Max 2TB giá từ 80.999.000đ - Mở bán 18/9",
          description:
            "iPhone 18 Pro Max 2TB giá từ 80.999.000đ, màu Đen, Bạc, Băng Thanh, Đỏ Burgundy. Đặt cọc từ 12/9, nhận hàng từ 18/9 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-18-pro-max-2tb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-18-pro-max-2tb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone 18 Pro Max 2TB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-18-pro-max-2tb",
            },
          ],
        },
      ],
    },
  },
  // iPhone Duo
  "/dien-thoai-iphone-duo-256gb": {
    title: "iPhone Duo 256GB giá từ 64.999.000đ - Mở bán 23/10",
    description:
      "iPhone Duo 256GB giá từ 64.999.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-duo-256gb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-duo-256gb",
      title:
        "iPhone Duo 256GB giá từ 64.999.000đ - Mở bán 23/10",
      description:
        "iPhone Duo 256GB giá từ 64.999.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iPhone-Duo-Star-White.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone Duo 256GB giá từ 64.999.000đ - Mở bán 23/10",
      description:
        "iPhone Duo 256GB giá từ 64.999.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iPhone-Duo-Star-White.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-duo-256gb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-duo-256gb",
          name:
            "iPhone Duo 256GB giá từ 64.999.000đ - Mở bán 23/10",
          description:
            "iPhone Duo 256GB giá từ 64.999.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-duo-256gb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-duo-256gb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone Duo 256GB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-duo-256gb",
            },
          ],
        },
      ],
    },
  },
  "/dien-thoai-iphone-duo-512gb": {
    title: "iPhone Duo 512GB giá từ 71.499.000đ - Mở bán 23/10",
    description:
      "iPhone Duo 512GB giá từ 71.499.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-duo-512gb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-duo-512gb",
      title:
        "iPhone Duo 512GB giá từ 71.499.000đ - Mở bán 23/10",
      description:
        "iPhone Duo 512GB giá từ 71.499.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iPhone-Duo-Star-White.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone Duo 512GB giá từ 71.499.000đ - Mở bán 23/10",
      description:
        "iPhone Duo 512GB giá từ 71.499.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iPhone-Duo-Star-White.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-duo-512gb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-duo-512gb",
          name:
            "iPhone Duo 512GB giá từ 71.499.000đ - Mở bán 23/10",
          description:
            "iPhone Duo 512GB giá từ 71.499.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-duo-512gb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-duo-512gb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone Duo 512GB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-duo-512gb",
            },
          ],
        },
      ],
    },
  },
  "/dien-thoai-iphone-duo-1tb": {
    title: "iPhone Duo 1TB giá từ 84.499.000đ - Mở bán 23/10",
    description:
      "iPhone Duo 1TB giá từ 84.499.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-duo-1tb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-duo-1tb",
      title:
        "iPhone Duo 1TB giá từ 84.499.000đ - Mở bán 23/10",
      description:
        "iPhone Duo 1TB giá từ 84.499.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iPhone-Duo-Star-White.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone Duo 1TB giá từ 84.499.000đ - Mở bán 23/10",
      description:
        "iPhone Duo 1TB giá từ 84.499.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iPhone-Duo-Star-White.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-duo-1tb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-duo-1tb",
          name:
            "iPhone Duo 1TB giá từ 84.499.000đ - Mở bán 23/10",
          description:
            "iPhone Duo 1TB giá từ 84.499.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-duo-1tb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-duo-1tb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone Duo 1TB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-duo-1tb",
            },
          ],
        },
      ],
    },
  },
  "/dien-thoai-iphone-duo-2tb": {
    title: "iPhone Duo 2TB giá từ 103.999.000đ - Mở bán 23/10",
    description:
      "iPhone Duo 2TB giá từ 103.999.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",

    canonical:
      "https://shopdunk.com/dien-thoai-iphone-duo-2tb",

    robots: "index,follow",

    openGraph: {
      locale: "vi_VN",
      type: "website",
      siteName: "ShopDunk",
      url:
        "https://shopdunk.com/dien-thoai-iphone-duo-2tb",
      title:
        "iPhone Duo 2TB giá từ 103.999.000đ - Mở bán 23/10",
      description:
        "iPhone Duo 2TB giá từ 103.999.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iPhone-Duo-Star-White.webp",
    },

    twitter: {
      card: "summary_large_image",
      title:
        "iPhone Duo 2TB giá từ 103.999.000đ - Mở bán 23/10",
      description:
        "iPhone Duo 2TB giá từ 103.999.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
      image:
        "https://api-production.shopdunkplus.com/uploaded/iphone-18/iphone-duo/iPhone-Duo-Star-White.webp",
    },

    schema: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-duo-2tb#webpage",
          url:
            "https://shopdunk.com/dien-thoai-iphone-duo-2tb",
          name:
            "iPhone Duo 2TB giá từ 103.999.000đ - Mở bán 23/10",
          description:
            "iPhone Duo 2TB giá từ 103.999.000đ, màu Trời Đêm và Trắng Ánh Sao. Đặt trước từ 16/10, mở bán từ 23/10 tại ShopDunk.",
          inLanguage: "vi-VN",
          breadcrumb: {
            "@id":
              "https://shopdunk.com/dien-thoai-iphone-duo-2tb#breadcrumb",
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id":
            "https://shopdunk.com/dien-thoai-iphone-duo-2tb#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Trang chủ",
              item: "https://shopdunk.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "iPhone",
              item: "https://shopdunk.com/iphone",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "iPhone 18",
              item: "https://shopdunk.com/dien-thoai-iphone-18",
            },
            {
              "@type": "ListItem",
              position: 4,
              name: "iPhone Duo 2TB",
              item:
                "https://shopdunk.com/dien-thoai-iphone-duo-2tb",
            },
          ],
        },
      ],
    },
  },
};
